import React, { useState, useEffect } from "react";
import { Sidebar } from "primereact/sidebar";

const InsightChatComponent = (props) => {
    const [visibleRight, setVisibleRight] = useState(true)
    const [dismisable, setDismisable] = useState(false)

    useEffect(() => {
        if (props.visible) {
            setVisibleRight(true)
        }
    }, [props.visible])

    const handleCloseRightSideBar = () => {
        setVisibleRight(false)
        props.close()
    };
    const handleHideRightSideBar = () => {
        setVisibleRight(false)
        props.hide()
    };

    

    const updatedMessages = props?.selectedchat?.map((message) => ({
        ...message,
        issent: message.managerId !== 0,
    }));

    const highlightText = (text, selected) => {
        // Remove punctuation and convert the selected text to lowercase
        const sanitizedSelected = selected?.replace(/[\?.,]+$/, "").toLowerCase();

        // url regex to match email addresses
        const urlRegex = /(https?:\/\/[^\s]+)/g;

        // Split the text into parts by the email regex
        const parts = text.split(urlRegex);

        return parts.map((part, index) => {
            if (urlRegex.test(part)) {
                // If the part matches an email address, highlight and underline it
                return (
                    <span
                        key={index}
                        style={{ textDecoration: "underline" }}
                    >
                        {part}
                    </span>
                );
            } else if (
                sanitizedSelected &&
                part.toLowerCase().includes(sanitizedSelected)
            ) {
                // If the part contains the selected text, highlight it
                const regex = new RegExp(`(${sanitizedSelected})`, "gi");
                return part.split(regex).map((subPart, subIndex) =>
                    subPart.toLowerCase() === sanitizedSelected ? (
                        <span
                            key={`${index}-${subIndex}`}
                            style={{
                                backgroundColor: "yellow",
                                color: "black",
                                padding: "2px"
                            }}
                        >
                            {subPart}
                        </span>
                    ) : (
                        subPart
                    )
                );
            } else {
                // Return the plain text part
                return part;
            }
        });
    };

    const ChatBox = () => {
        return (
            <div className="chat-container">
                {updatedMessages?.map((chat) => (
                    <div key={chat.chatId} className="chat-item" >
                        {/* Sender Name */}
                        <span className={`chat-sender ${chat.issent ? "senderName" : "receivername"}`}>{chat.messageBy}</span>
                        {/* Message Box */}
                        <div className={`chat-message ${chat.issent ? "sent" : "received"}`}>
                            {highlightText(chat.messageText, props.selectedQuestion)}
                        </div>
                    </div>
                ))}
            </div>
        );
    };
    return (
        <>
            <Sidebar
                className="insights-rightsidebar"
                dismissable={dismisable}
                visible={visibleRight}
                position="right"
                onHide={() => handleCloseRightSideBar()}
            >
                <div className="rightsidebar-header">
                    <div>
                        <button className="rightsidebar-arrow" onClick={handleHideRightSideBar} aria-label="Close">
                            <i className="fa-solid fa-arrow-left-long"></i>
                        </button>
                        <label className="chatsidebar-header-label">ChatsID:{props?.selectedchatid}</label>
                    </div>
                    <button className="rightsidebar-close-btn" onClick={handleCloseRightSideBar} aria-label="Close">
                        <i className="pi pi-times"></i>
                    </button>
                </div>
                {ChatBox()}
            </Sidebar>
        </>
    );
}

export default InsightChatComponent;
